import React, { FunctionComponent } from 'react';
import { Background } from '../../../types/background';
import RichText from '../../RichText';
import './styles.scss';

type Template = 'default' | '40-60' | '60-40';

type TwoColumnsProps = {
  data: {
    template: Template;
    background: Background;
    leftContent: any;
    rightContent: any;
  };
}


const TwoColumns: FunctionComponent<TwoColumnsProps> = ({ data }) => {
  const template: Template = data.template;
  const columnClass = template === '40-60' ? 'columns-40-60' : (template === '60-40' ? 'columns-60-40' : '');

  return (
    <section className={`two-columns ${data.background}`}>
      <div className={columnClass}>
        <RichText
          value={data.leftContent}
        />
        <RichText
          value={data.rightContent}
        />
      </div>
    </section>
  );
}

export default TwoColumns;
